import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, MessageCircle, FileX } from 'lucide-react';
const badges = [{
  icon: Zap,
  title: 'Acceso inmediato',
  desc: 'Entrás al grupo en minutos'
}, {
  icon: FileX,
  title: 'Sin contratos',
  desc: 'Sin letra chica ni ataduras'
}, {
  icon: MessageCircle,
  title: 'Soporte directo',
  desc: 'Respondemos por WhatsApp'
}, {
  icon: Shield,
  title: 'Garantía 7 días',
  desc: 'Devolución sin preguntas'
}];
export function TrustSection() {
  return <section className="py-16 bg-[#080808]" data-id="element-436">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-437">
        {/* Guarantee block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-8 bg-[#0f0f0f] border border-[#C9A84C]/30 p-8 md:p-10 mb-10 relative overflow-hidden" data-id="element-438">
          {/* Corner accents */}
          <div className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-[#C9A84C]" data-id="element-439" />
          <div className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-[#C9A84C]" data-id="element-440" />

          {/* Shield */}
          <div className="shrink-0 flex flex-col items-center gap-2" data-id="element-441">
            <div className="w-20 h-20 rounded-full bg-[#C9A84C]/10 border-2 border-[#C9A84C]/40 flex items-center justify-center" data-id="element-442">
              <Shield className="w-9 h-9 text-[#C9A84C]" data-id="element-443" />
            </div>
            <span className="text-[#C9A84C] text-[10px] font-bold tracking-widest uppercase" data-id="element-444">
              Garantía
            </span>
          </div>

          {/* Text */}
          <div className="text-center md:text-left" data-id="element-445">
            <h3 className="font-['Bebas_Neue'] text-3xl md:text-4xl text-white mb-2" data-id="element-446">
              7 DÍAS O TE DEVOLVEMOS EL DINERO
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed max-w-lg" data-id="element-447">
              Si en los primeros 7 días sentís que no es lo que esperabas,{' '}
              <span className="text-white font-medium" data-id="element-448">
                te devolvemos el 100% sin preguntas.
              </span>{' '}
              La única condición: que hayas participado de al menos un encuentro
              en vivo. Así de seguros estamos de lo que ofrecemos.
            </p>
          </div>
        </motion.div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-449">
          {badges.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-col items-center text-center gap-2 bg-[#0f0f0f] border border-white/5 px-4 py-5" data-id="element-450">
              <div className="w-10 h-10 rounded-full bg-[#C9A84C]/10 flex items-center justify-center mb-1" data-id="element-451">
                <b.icon className="w-5 h-5 text-[#C9A84C]" data-id="element-452" />
              </div>
             <p className="text-white text-sm font-semibold" data-id="element-453">{b.title}</p>
              <p className="text-gray-500 text-xs leading-snug" data-id="element-454">{b.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}